import styled from 'styled-components';

const Subtitle = styled.span`
  text-transform: uppercase;
  font-weight: 300;
  font-size: 18px;
  line-height: 28px;
`;

export default Subtitle;
